var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn Social Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22",
    width: 50,
    height: 50,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1663 14.779C17.1659 15.5157 16.8671 16.222 16.3355 16.7427C15.8039 17.2633 15.0831 17.5556 14.3317 17.5552C13.5803 17.5549 12.8599 17.2619 12.3288 16.7407C11.7978 16.2196 11.4996 15.5129 11.5 14.7762C11.5004 14.0396 11.7992 13.3332 12.3308 12.8126C12.8624 12.2919 13.5832 11.9996 14.3346 12C15.086 12.0004 15.8065 12.2934 16.3375 12.8145C16.8686 13.3357 17.1667 14.0423 17.1663 14.779ZM17.2513 19.6121H11.585V37H17.2513V19.6121ZM26.2041 19.6121H20.5661V37H26.1474V27.8755C26.1474 22.7925 32.9045 22.3203 32.9045 27.8755V37H38.5V25.9867C38.5 17.4178 28.499 17.7372 26.1474 21.9453L26.2041 19.6121Z",
    fill: "#1C1E2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInImg);
export default __webpack_public_path__ + "static/media/LinkedInImg.63cf08f27518789902e1e00ec67219ad.svg";
export { ForwardRef as ReactComponent };